import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { Layout, Menu, Tooltip } from 'antd';
import type { MenuProps } from 'antd';
import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import smallcase from '~/assets/logo-white.png';
import smallcaseIconWhite from '~/assets/smallcaseIconWhite.png';
import { logoutUser } from '~/services/authService';
import { useAuthStore } from '~/store/auth';

const { Sider } = Layout;

const items = [
    {
        key: 'dashboard',
        icon: <UserOutlined />,
        label: 'Loan Dashboard',
    },
];

const Sidebar = () => {
    const { isAuthenticated, roles } = useAuthStore();
    const [isCollapsed, setIsCollapsed] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const handleMenuItemClick: MenuProps['onClick'] = (e) => {
        navigate(`/${e.key}`);
    };

    const getDefaultSelectedKey = () => {
        const path = location.pathname;
        return path === '/dashboard' ? 'dashboard' : '';
    };

    if (!isAuthenticated || !roles?.length) {
        return null;
    }

    return (
        <Sider
            breakpoint="lg"
            collapsedWidth="60"
            collapsible
            onCollapse={() => setIsCollapsed(!isCollapsed)}
            className="relative"
        >
            <Link to={isAuthenticated ? '/dashboard' : '/'}>
                <div className="cursor-pointer flex items-center justify-center w-full border-b-[1px] border-gray-600 mb-2">
                    <img
                        className={`${isCollapsed ? 'h-[38px]' : 'h-[45px]'} p-1 my-1`}
                        src={isCollapsed ? smallcaseIconWhite : smallcase}
                        alt="Logo"
                    />
                </div>
            </Link>
            <Menu
                theme="dark"
                mode="inline"
                defaultSelectedKeys={['dashboard']}
                selectedKeys={[getDefaultSelectedKey()]}
                items={items}
                onClick={handleMenuItemClick}
            />
            <Tooltip title="Logout" placement="right">
                <button
                    className="text-white border-b border-gray-600 p-2 w-full sticky top-[calc(100vh-95px)] gap-2 flex items-center justify-center"
                    type="button"
                    onClick={logoutUser}
                >
                    <LogoutOutlined className="h-[30px] font-bold" />
                    {!isCollapsed && 'Logout'}
                </button>
            </Tooltip>
        </Sider>
    );
};

export default Sidebar;
